'use es6';

import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import MomentDate from '../propTypes/MomentDate';
import FilterOperatorType from 'customer-data-filters/components/propTypes/FilterOperatorType';
import { DATE } from 'customer-data-objects/property/PropertyTypes';
import { hasRemoveTimezoneForDates } from '../../permissions/gates';
import EqualTimePoint from '../../filterQueryFormat/operator/EqualTimePoint';
import BeforeTimePoint from '../../filterQueryFormat/operator/BeforeTimePoint';
import AfterTimePoint from '../../filterQueryFormat/operator/AfterTimePoint';
import BetweenTimePoints from '../../filterQueryFormat/operator/BetweenTimePoints';
import NotBetweenTimePoints from '../../filterQueryFormat/operator/NotBetweenTimePoints';
import Equal from '../../filterQueryFormat/operator/Equal';
import Less from '../../filterQueryFormat/operator/Less';
import Greater from '../../filterQueryFormat/operator/Greater';
import InRange from '../../filterQueryFormat/operator/InRange';
import NotInRange from '../../filterQueryFormat/operator/NotInRange';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DisplayValueDate({
  value,
  operator,
  getIsUngated
}) {
  if (!value) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFilters.DisplayValueDate.invalid"
    });
  }
  const getShowTimeFormat = () => {
    const {
      hasTimezones
    } = operator;
    if (!hasRemoveTimezoneForDates(getIsUngated) || operator.field.type !== DATE || operator.constructor !== EqualTimePoint && operator.constructor !== BeforeTimePoint && operator.constructor !== AfterTimePoint && operator.constructor !== BetweenTimePoints && operator.constructor !== NotBetweenTimePoints && operator.constructor !== Equal && operator.constructor !== Less && operator.constructor !== Greater && operator.constructor !== InRange && operator.constructor !== NotInRange) {
      return true;
    }
    return hasTimezones;
  };
  if (I18n.moment.isMoment(value)) {
    // FormattedDateTime component displays date in a portalTz so if a moment date
    // passed to it has a different TZ it will be converted. Since we need to display
    // a date in the filter's timezone we don't want this conversion to happen.
    // To prevent the conversion the value is manually switched to a portalTz
    // but without applying time offset between the timezones
    const valueWithPortalTz = value.clone().tz(I18n.moment.portalTz().tz(), true);
    const tzFormat = value.tz() || value.isUTC() ? 'z' : 'Z';
    return /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedDateTime, {
        format: "L",
        type: "portalTz",
        value: valueWithPortalTz
      }), getShowTimeFormat() && ` (${value.format(tzFormat)})`]
    });
  }
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(FormattedDateTime, {
      format: "L",
      type: "portalTz",
      value: I18n.moment.portalTz(value)
    }), getShowTimeFormat() && ` (${I18n.moment.portalTz().format('z')})`]
  });
}
DisplayValueDate.propTypes = {
  getIsUngated: PropTypes.func.isRequired,
  operator: FilterOperatorType.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, MomentDate])
};